<template lang="">
    <div class="orderDetail">
        <div class="orderDetail-top">
            <div class="top-1 top-2"> <div>订单编号：<span>{{detailInfo.order_sn}}</span></div>  <button @click="copy(detailInfo.order_sn)">复制</button>  </div>
            <div class="top-1">下单时间：{{detailInfo.order_time}}</div>
            <div class="top-1">交易状态：{{detailInfo.order_status?detailInfo.order_status:"暂无交易状态"}} </div>
        </div>
        <div class="orderDetail-center">
            <div class="center-title">收货信息</div>
            <div class="center-content">
                <div>收货人：{{detailInfo.order_user_name}}</div>
                <div class="content-1">联系方式：{{detailInfo.order_user_mobile}}</div>
                <div class="content-1">收货地址：{{detailInfo.order_user_address}}</div>
            </div>
        </div>
        <div class="orderDetail-center orderDetail-bottom">
            <div class="center-title">商品信息</div>
            <div class="orderItem" v-for="item in detailInfo.product" :key="item.name">
                <div class="item-center">
                    <div class="center-left">
                        <img :src="item.order_product_thumb" />
                    </div>
                    <div class="center-right">
                        <div class="right-title">{{item.order_product_name}} </div>
                        <div class="right-name">{{detailInfo.order_card_name}}</div>
                        <div class="right-product">{{detailInfo.order_time}}</div>
                    </div>
                </div>
            </div>
            <div class="buttons">
               <a href="tel:400-900-3301"> <button>联系客服</button></a>
            </div>
        </div>
        <div class="orderDetail-end">
            <img :src="detailInfo.order_qrcode_url" />
            <div>
                <div>长按识别二维码</div>
                 <div>订单状态实时更新推送</div>
            </div>
        </div>
    </div>
</template>
<script>
import {orderDetail} from "@api"

import wx from 'weixin-js-sdk'
export default {
    data(){
        return{
            order_sn:"",
            baseUrl:"",
            detailInfo:{}

        }
    },
    created(){
       this.order_sn = this.$route.query.order_sn
       this.orderDetail()
    },
    methods:{
        /**
         * 获取详情信息
         */
        async orderDetail(){
           const [err,data] = await orderDetail({
               order_sn:this.order_sn  
           })
           if(err) return console.warn(err)
           this.detailInfo=data
           let json = JSON.parse(data.page_json)
            wx.config(
                json
            );
            wx.hideMenuItems({
            menuList: [
                "menuItem:exposeArticle",
                "menuItem:refresh",
                "menuItem:share:appMessage",
                "menuItem:share:timeline",
                "menuItem:share:qq",
                "menuItem:share:weiboApp",
                "menuItem:favorite",
                "menuItem:share:facebook",
                "menuItem:share:QZone",
                "menuItem:openWithQQBrowser",
                "menuItem:openWithSafari",
                "menuItem:share:email"
            ] 
            });
            wx.hideAllNonBaseMenuItem();
        },
        /**
         * 复制订单
         */
        copy(shareLink){
                var input = document.createElement("input");   // 直接构建input
                input.value = shareLink;  // 设置内容
                document.body.appendChild(input);    // 添加临时实例
                input.select();   // 选择实例内容
                document.execCommand("Copy");   // 执行复制
                document.body.removeChild(input); // 删除临时实例
                this.$toast("复制成功");
        }
        
    }
}
</script>
<style lang="scss" scoped>
    .orderDetail{
        .orderDetail-top{
            width:100%;
            height:186px;
            box-sizing: border-box;
            background:rgba(255,255,255,1);
            padding: 30px 17px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            font-size:26px;
            font-family:PingFang SC;
            font-weight:bold;
            color:rgba(134,134,134,1);
            border-bottom: 14px solid #F0F0F0;
            .top-2{
                display: flex;
                justify-content: space-between;
                button{
                    background: #fff;
                    border: 1px solid #CDCDCD;
                    font-size: 28px;
                    width: 90px;
                    height: 40px;
                }
            }
        }
        .orderDetail-center{
            padding-bottom:68px ;
            border-bottom: 14px solid #F0F0F0;
             .center-title{
                padding:20px 30px;
                border-bottom: 1px solid #F0F0F0;
                font-size:26px;
             }
             .content-1{
                 margin-top:32px;
             }
             .buttons{
                 width: 100%;
                 text-align: center;
                 padding-top:52px ;
                 padding-bottom: 20px;
                 button{
                        width:710px;
                        height:80px;
                        background:rgba(248,248,248,1);
                        border:2px solid rgba(231, 231, 231, 1);
                        border-radius:8px;
                        font-size:30px;
                        font-family:PingFang SC;
                        font-weight:bold;
                        color:rgba(51,51,51,1);
                 }
             }
        }
        
        .orderDetail-bottom{
             padding-bottom:0 ;
        }
        .orderDetail-end{
            padding-top:76px;
            padding-bottom: 76px;
            text-align: center;
            font-size:32px;
            font-family:PingFang SC;
            font-weight:500;
            color:rgba(48,48,48,1);
            line-height:44px;
            img{
                width: 362px;
            }
        }
        .center-content{
            padding:30px 20px;
        }
        .orderItem{
            width: 100%;
            background: #fff;
            margin-bottom: 16px;
             border-bottom: 1px solid #F0F0F0;
            .item-top{
                padding: 0 18px;
                height: 82px;
                line-height: 82px;
                background:rgba(247,247,247,1);
                font-size:28px;
                font-family:PingFang SC;
                font-weight:500;
                color:rgba(252,133,53,1);
            }
            .item-center{
                padding: 30px 18px;
                display: flex;
                .center-left{
                    margin-right: 16px;
                    img{
                        width: 144px;
                        height: 144px;
                    }
                }
                .center-right{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .right-title{
                        font-size:24px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(77,77,77,1);
                        line-height:35px;
                    }
                    .right-name{
                        font-size:22px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(125,125,125,1);
                    }
                    .right-product{
                        font-size:22px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(102,102,102,1);
                    }
                }
            }
            
        }
       
    }
</style>